export const translations: any = {
    id: 'ID',
    name: 'Nombre',
    originalName: 'Nombre',
    lastName: 'Apellidos',
    user: 'Usuario',
    email: 'Email',
    address: 'Dirección',
    cif: 'CIF',
    commercialNetwork: 'Red comercial',
    accessThrowCommercialNetworkIp: 'Acceso IP',
    userRoles: 'Rol',
    department: 'Departamento',
    logo: 'Logo',
    profileImg: 'Imagen de perfil',
    active: 'Activo',
    createdAt: 'Creación',
    score: "Puntuación",
    type: "Tipo",
    student: "Alumno",
    date: 'Fecha',
    orderCampaignAssignedUserName: 'Dinamizador',
    displayOrder: 'Orden de visualización',
    requiresSchedule: 'Requiere agendar',
    generatesAutomaticIncidence: 'Genera incidencia',
    isActive: 'Activo',
    contractCode: 'Código de contrato',
    trainingActionCode: 'Acción formativa',
    courseLabel: 'Producto',
    studentFullName: 'Nombre del alumno',
    progressPercentage: 'Progreso',
    trackingLabel: 'Seguimiento',
    lastContactAt: 'Último contacto',
    productStatusName: 'Estado del producto',
    incidence: 'Incidencia relacionada',
    currentStageLabel: 'Etapa de campaña',
    countsAsFailedVerificationCall: 'Cuenta como llamada fallida',
    documentNumber: 'CIF/NIF',
    typeLabel: 'Tipo',
    coordinatorName: 'Nombre del coordinador',
    facilitatorName: 'Nombre del dinamizador',
    facilitatorUserEmail: 'Correo electrónico del dinamizador',
    totalCalls: 'Total de llamadas',
    totalStartCalls: 'Llamadas etapa de inicio',
    totalFollowUpCalls: 'Llamadas etapa de seguimiento',
    totalEndCalls: 'Llamadas etapa de fin',
    totalRealizedCalls: 'Total de llamadas realizadas',
    totalPendingCalls: 'Total de llamadas pendientes',
    productDates: 'Fechas',
    classificationName: 'Tipificación',
    targetDepartment: 'Departamento encargado',
    openedAt: 'Fecha de apertura',
    openingMessage: 'Mensaje de solicitud',
    closingMessage: 'Mensaje de respuesta',
    statusLabel: 'Estado de la solicitud',
    openedBy: 'Usuario solicitante',
    closedBy: 'Usuario resolutor',
    closedAt: 'Fecha de cierre',
    stageLabel: 'Etapa de campaña',
    scheduledAt: 'Fecha de agenda',
    automaticIncidenceCode: 'Incidencia generada (si procede)',
    totalAmount: 'Precio',
    currentContractStatusDate: 'Fecha Estado',
    currentContractStatus: 'Estado Contrato',
    currentContractProductStatus: 'Producto Contrato',
    fundaeGrouping: 'Agrupación FUNDAE',
    orderCampaignStage: 'Etapa de campaña',
    currentContractInvoicingStatus: 'Facturación Contrato',
    currentContractIncidenceStatus: 'Incidencia Contrato',
    currentInvoicingStatus: 'Estado Factura',
    currentProductStatus: 'Estado Producto',
    currentBlockedStatus: 'Estado Bloqueo',
    currentBlockedStatusDate: 'Fecha Estado Bloqueo',
    currentIncidenceStatusId: 'Estado Incidencia',
    currentCommissionStatusId: 'Estado Comisión',
    product: 'Producto',
    clientProvince: 'Provincia Cliente',
    clientCifNif: 'CIF/NIF Cliente',
    updatedAt: 'Actualización',
    lastLogin: 'Último acceso',
    lastLoginAt: 'Último acceso',
    invoiceNumber: 'Nº factura',
    expirationDate: 'Fecha de expiración',
    paymentDate: 'Fecha de pago',
    invoiceDate: 'Fecha de factura',
    actionType: 'Tipo de acción realizada',
    ipAddress: 'Dirección IP',
    changeCount: 'Número de cambios',
    userAgent: 'Navegador',
    requestRoute: 'Ruta de la petición',
    requestMethod: 'Método de la petición',
    changes: 'Detalle de cambios realizados',
    totalPrice: 'Precio total',
    totalProducts: 'Total productos',
    tax: 'IVA',
    totalTaxesAmount: 'Total Impuestos',
    taxableAmount: 'Base Imponible',
    paymentAt: 'Fecha de pago',
    corporation: 'Empresa',
    entityType: 'Entidad',
    documentType: 'Tipo de documento',
    subdirectory: 'Directorio',
    currentStatus: 'Estado',
    status: 'Estado',
    state: 'Estado',
    currentIncidence: 'Incidencia actual',
    company: 'Organización',
    description: 'Descripción',
    statusOrder: 'Orden',
    productType: 'Tipo de producto',
    consultancyFieldsRequired: 'Asesoría obligatoria',
    draftStatus: 'Borrador',
    initialStatus: 'Inicial',
    satisfactoryStatus: 'Satisfactorio',
    unsatisfactoryStatus: 'Insatisfactorio',
    requiresKoReason: 'Motivo',
    motivo: 'Motivo',
    clientInvoiceStatus: 'Factura cliente',
    tutorInvoiceStatus: 'Factura tutor',
    internalInvoiceStatus: 'Factura interna',
    scoreDelivery: 'Aumenta puntuación',
    scoreRemove: 'Resta puntuación',
    generateContractCommission: 'Generar comisión',
    paidStatus: 'Pagado',
    unpaidStatus: 'Impagado',
    sendOrderCoursesInformationEmail: 'Email info cursos',
    isSendSmsContractToSign: 'SMS enviado',
    isExportToXmlStart: 'XML inicio exportado',
    isExportToXmlEnd: 'XML fin exportado',
    xmlStartExported: 'XML inicio exportado',
    xmlEndExported: 'XML fin exportado',
    code: 'Código',
    incidenceType: 'Tipo de incidencia',
    contract: 'Contrato',
    contractAmount: 'Importe Contrato',
    commissionPercentage: '% Comisión',
    totalCommission: 'Total Comisión',
    adjustments: 'Ajustes',
    manager: 'Responsable',
    subject: 'Asunto',
    weeklyHours: 'Horas semanales',
    amount: 'Importe',
    nifCif: 'NIF/CIF',
    telephone: 'Teléfono',
    telephoneSecondary: 'Tfno. secundario',
    comments: 'Comentarios',
    documents: 'Documentos',
    availability: 'Disponibilidad',
    platformUser: 'Usuario de plataforma',
    postalCode: 'Código postal',
    province: 'Provincia',
    town: 'Localidad',
    tutorType: 'Tipo de tutor',
    gender: 'Género',
    birthDate: 'F. Nacimiento',
    genderViolenceVictim: 'Víctima de violencia de género',
    terrorismVictim: 'Víctima de terrorismo',
    client: 'Cliente',
    other: 'Otros',
    companyName: 'Razón social',
    clientCompanyName: 'Razón social',
    callDate: 'Fecha de llamada',
    duration: 'Duración',
    cifNif: 'CIF/NIF',
    cnae: 'CNAE',
    currentCredits: 'Créditos',
    personResponsibleName: 'Nombre (responsable)',
    personResponsibleNif: 'NIF (responsable)',
    lastComment: 'Último comentario',
    comment: 'Comentario',
    credits: 'Créditos',
    entityOrder: 'Orden',
    modifiedAt: 'Fecha de modificación',
    contact: 'Persona de contacto',
    hoursNumber: 'Número de horas',
    orderType: 'Tipo de pedido',
    orderTypes: 'Tipo de pedido',
    contracts: 'Nº contratos',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    collectionDate: 'Fecha de cobro',
    orderDate: 'Fecha de pedido',
    calendarDays: 'Días naturales',
    workingDays: 'Días laborables',
    studentName: 'Alumno',
    commercialNetworkName: 'Red comercial',
    commercialName: 'Agente',
    XMLType: "Tipo de XML",
    personInformation: 'Información de contacto',
    clientTelephone: 'Telf. cliente',
    order: 'Pedido',
    fileName: 'Nombre del archivo',
    actionId: 'OCM ID',
    callId: 'Llamada',
    receivedAt: 'Fecha de recepción',
    currentDueStatus: 'Estado de venc.',
    currentDueManagementStatus: 'Estado gestión de venc.',
    invoice: 'Factura',
    reminder: 'Recordatorio',
    reminderDate: 'Fecha de recordatorio',
    reminderResponsible: 'Responsable de recordatorio',
    notes: 'Notas',
    groupCode: "Código de grupo",
    paymentMethod: 'Método de pago',
    productTypes: 'Tipos de producto',
    amountRemitted: 'Cantidad remesada (€)',
    bankName: 'Nombre del banco',
    paymentIssueIdentifier: 'Identificador del pago',
    quantityRemitted: 'Nº de venc. remesados',
    isConfirmed: 'Confirmada',
    invoiceType: 'Tipo de factura',
    providingCorporation: 'Organización impartidora',
    complementsNumber: 'Nº complementos',
    useType: 'Tipo de uso',
    resetInterval: 'Intervalo de reinicio',
    organisingCorporations: 'Empresas organizadoras',
    resetIntervalCustomDates: 'Fechas personalizadas',
    userName: 'Nombre',
    departmentName: 'Departamento',
    products: 'Productos',
    statusEntity: 'Entidad de estado relacionada',
    dailyCurrent: 'Diario',
    weeklyCurrent: 'Semanal',
    monthlyCurrent: 'Mensual',
    renewalSettings: 'Configuración de renovación',
    renewalDaysNumber: 'Días antes de la renovación',
    currentStatusName: 'Estado',
    originalContractCode: 'Contrato original',
    generatedContractCode: 'Contrato generado',
    productTypeName: 'Tipo de producto',
    productName: 'Producto',
    origin: 'Origen',
    agent: 'Agente',
    targetDate: 'Fecha objetivo',
    hasAgreementSigned: 'Convenio',
    invoiceCodeFormat: 'Formato código factura',
    invoiceSequence: 'Secuencia factura',
    contractIds: 'Contratos vinculados',
    linkedContractIds: 'Contratos vinculados',
};

export const imageFields = [
    'logo',
    'profileImg',
];

export const translateColumnName = (key: any) => {
    // Convierte camelCase a "Camel Case"
    const formattedKey = key.replace(/([A-Z])/g, ' $1').trim();

    // Retorna la traducción si existe, o el nombre formateado
    return translations[key] || formattedKey.charAt(0).toUpperCase() + formattedKey.slice(1);
};
